import { InjectionToken } from "@angular/core";

export interface LokiConfig {
  container: string;
}

export const LOKI_CONFIG = new InjectionToken<LokiConfig>("LOKI_CONFIG");
